import { Cancelled, is } from '@bldsoft/cappie/rest'
import { api } from '@setplex/tria-api'
import { attach, createEvent, createStore, sample } from 'effector'
import { debounce } from 'patronum'
import { versioning } from '~/core/flags'
import { register } from '~/core/repository'
import { lt } from '~/shared/tools/semver'
import { AUTOCOMPLETE_REQUEST_DELAY_MS } from './constants'

export const getSearchAutocompleteFx = attach({
  effect: api.globalSearch.getSearchAutocompleteAbortableFx,
})

export const resetAutocomplete = createEvent()
export const pickAutocompleteItem = createEvent<{ suggestionText: string }>()
export const pushAutocompleteTyping = createEvent()
export const getSearchAutocomplete = createEvent<string>()

export const debouncedAutocompleteTyping = debounce({
  source: pushAutocompleteTyping,
  timeout: AUTOCOMPLETE_REQUEST_DELAY_MS,
})

export const $searchAutocompleteSuggestions = createStore<string[]>([])
  .on(resetAutocomplete, () => [])
  .on(getSearchAutocompleteFx.doneData, (_, result) => result)
  .on(getSearchAutocompleteFx.failData, (list, err) =>
    is(err, Cancelled) ? list : []
  )

export const $searchAutocompleteItems = $searchAutocompleteSuggestions.map(
  (list) => list.map((suggestionText) => ({ suggestionText }))
)

export const $showAutocompleteMenu = $searchAutocompleteSuggestions.map(
  (suggestions) => suggestions.length > 0
)

sample({
  clock: getSearchAutocomplete,
  source: versioning.$wbsVersion,
  filter: (version) => version !== null && !lt(version, [3, 22, 0]), // version >= 3.22
  fn: (_, q) => ({ q }),
  target: getSearchAutocompleteFx,
})

register($showAutocompleteMenu, '$search/showAutocompleteMenu')
register($searchAutocompleteItems, '$search/autocompleteItems')
register(resetAutocomplete, 'search/resetAutocomplete')
register(pickAutocompleteItem, 'search/pickAutocompleteItem')
